import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IInlineChatSessionService = ( createDecorator('IInlineChatSessionService'));
export { IInlineChatSessionService };
